import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { ScanHistory } from "#/types/scan-history";
import type {
  CreateSubClientPayload,
  SubClient,
  SubClientAnalytics,
} from "#/types/subClient";

export const subClientsApi = {
  create: (body: CreateSubClientPayload): Promise<ApiResponse<SubClient>> =>
    api.post("/sub-client", body),
  update: (
    id: number,
    body: Partial<CreateSubClientPayload>,
  ): Promise<ApiResponse<SubClient>> => api.patch(`/sub-client/${id}`, body),
  getAll: (
    params: BaseFilterParams,
  ): Promise<ApiResponse<Paginated<SubClient[]>>> =>
    api.get("/sub-client", { params }),
  getById: (id: number): Promise<ApiResponse<SubClient>> =>
    api.get(`/sub-client/${id}`),
  getAnalytics: (id: number): Promise<ApiResponse<SubClientAnalytics>> =>
    api.get(`/sub-client/${id}/analytics`),
  getScanHistory: (
    id: number,
    params: BaseFilterParams,
  ): Promise<ApiResponse<Paginated<ScanHistory[]>>> =>
    api.get(`/sub-client/${id}/scan-history`, { params }),
  delete: (id: number): Promise<ApiResponse<null>> =>
    api.delete(`/sub-client/${id}`),
};
